<div *ngIf="errorMessage" class="student-page-container wide-xs">
	<div class="content-container content-container-sm">
		<div *ngIf="errorMessage" class="alert alert-danger GsAlert spacer-lg" khA11yAlert>
			<h4>{{ 'VERIFY_EMAIL.ERROR' | translate }}</h4>
            <div>{{errorMessage}}</div>
		</div>
		<div class="center">
			<a [routerLink]="loginRoute">{{ 'VERIFY_EMAIL.LOG_IN' | translate }}</a>
		</div>
		
	</div>
</div>
